import {
    Component,
    input,
    computed,
    ChangeDetectionStrategy,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgIcon } from '@ng-icons/core'
import { NavigationGroup } from '../sidebar-admin-default/sidebar.model'

@Component({
    selector: 'app-sidebar-vendor',
    imports: [RouterModule, NgIcon],
    templateUrl: './sidebar-vendor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sidebar-vendor.component.css',
})
export class SidebarVendorComponent {
    isCollapsed = input(false)
    logoSrc = input('assets/images/logo_vendor.png')
    logoAlt = input('Benefit Logo')
    companyName = input('ABC Restaurant')
    navigationGroups = input<NavigationGroup[]>([])

    showLabel = computed(() => !this.isCollapsed())
}
